var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('sidenav', {
    class: _vm.curClasses,
    attrs: {
      "orientation": _vm.orientation
    }
  }, [_vm.orientation !== 'horizontal' ? _c('div', {
    staticClass: "app-brand demo"
  }, [_c('router-link', {
    staticClass: "app-brand-text demo sidenav-text font-weight-normal ml-2",
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "app-brand-logo demo"
  }, [_vm.$store.getters.generic.settings && _vm.$store.getters.generic.settings.dashboard_logo ? _c('img', {
    attrs: {
      "src": _vm.backend_url + _vm.$store.getters.generic.settings.dashboard_logo,
      "alt": "img"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('a', {
    staticClass: "layout-sidenav-toggle sidenav-link text-large ml-auto",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function click($event) {
        return _vm.toggleSidenav();
      }
    }
  }, [_c('i', {
    staticClass: "ion ion-md-menu align-middle"
  })])], 1) : _vm._e(), _vm._v(" "), _vm.orientation !== 'horizontal' ? _c('div', {
    staticClass: "sidenav-divider mt-0"
  }) : _vm._e(), _vm._v(" "), _vm.isReports ? _c('div', {
    staticClass: "sidenav-inner",
    class: {
      'py-1': _vm.orientation !== 'horizontal'
    },
    staticStyle: {
      "height": "26rem"
    }
  }, [_c('ReportLayout')], 1) : _c('div', {
    staticClass: "sidenav-inner",
    class: {
      'py-1': _vm.orientation !== 'horizontal'
    },
    staticStyle: {
      "height": "26rem"
    }
  }, [_vm._l(_vm.notMenuListFilter(_vm.menu_list), function (page) {
    return _c('sidenav-router-link', {
      key: page.title,
      attrs: {
        "to": {
          name: page.name
        },
        "icon": page.icon,
        "exact": true
      }
    }, [_vm._v("\n      " + _vm._s(_vm.$t(page.title)) + "\n    ")]);
  }), _vm._v(" "), _vm._l(_vm.menuListFilter(_vm.menu_list), function (page) {
    return _c('sidenav-menu', {
      key: page.title,
      attrs: {
        "to": {
          name: page.name
        },
        "icon": page.icon,
        "active": _vm.isMenuActive(_vm.current_page),
        "open": _vm.isMenuOpen(page)
      }
    }, [_c('template', {
      slot: "link-text"
    }, [_vm._v(_vm._s(_vm.$t(page.title)))]), _vm._v(" "), _vm._l(_vm.childrenFilter(page.children), function (child) {
      return _c('sidenav-router-link', {
        key: child.title,
        attrs: {
          "to": {
            name: child.name
          },
          "icon": child.icon,
          "exact": true
        }
      }, [_vm._v("\n        " + _vm._s(_vm.$t(child.title)) + "\n      ")]);
    })], 2);
  })], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }